import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import { GridContent } from "@/src/components/grid/components/GridContent";
import { Card } from "@/src/components/cards/components/Card";
import { CardTheme } from "@/src/components/cards/components/Card/types";
import clsx from "clsx";
import { CardRow } from "@/src/components/cards/components/CardRow";
import { convertISODateStringToMonthAndYear } from "./helpers";
import SwooshHandleAndImageHeaderWithAchievement from "./components/SwooshHandleAndImageHeader";
import { useGetPublicUserDataBySwooshHandle } from "./services/useGetPublicUserDataBySwooshHandle";
import ActionsMenu from "./components/ActionsMenu";
import QueryLoadingWrapper from "@/src/components/QueryLoadingWrapper";
import { ERROR_CODES } from "@/libs/error/types";
import { usePageView } from "@/libs/analytics/useAnalytics";
import ProfileTabs from "./components/ProfileTabs";

type Props = {
  /* Swoosh Handle of the Profile Being Viewed*/
  swooshHandle: string;
};

const Profile: React.FC<Props> = ({ swooshHandle }) => {
  const { isLoading: userLoading } = useCurrentUser();
  // override config to catch when user data does not exist
  const {
    userProfile,
    isLoading: publicUserDataLoading,
    error,
  } = useGetPublicUserDataBySwooshHandle(swooshHandle, {
    useErrorBoundary: ({ response }) =>
      response !== undefined &&
      (response?.status >= ERROR_CODES.INTERNAL_ERROR ||
        response.status === ERROR_CODES.BAD_REQUEST),
  });
  const dateJoined = convertISODateStringToMonthAndYear(userProfile?.createdAt);
  usePageView();

  return (
    <QueryLoadingWrapper isLoading={userLoading || publicUserDataLoading}>
      <GridContent
        classes={{
          root: "flex w-full h-fit justify-center dark",
          inner: "w-full h-fit flex flex-col mt-14",
        }}
      >
        <Card
          className={clsx("mb-base h-fit w-full")}
          theme={CardTheme.inherit}
          hasBorder={false}
        >
          <QueryLoadingWrapper isLoading={publicUserDataLoading || !!error}>
            <CardRow
              className={clsx("flex justify-between", "flex-col lg:flex-row")}
            >
              <SwooshHandleAndImageHeaderWithAchievement
                dateJoined={dateJoined}
                swooshHandle={swooshHandle}
                image={userProfile?.avatar?.large} // we are by default using large for resolution 200 x 200
              />

              <ActionsMenu swooshHandle={swooshHandle} />
            </CardRow>
          </QueryLoadingWrapper>
        </Card>

        <hr className="border-gray-600 pb-[18px] md:pb-8" />
        <ProfileTabs swooshHandle={swooshHandle} />
      </GridContent>
    </QueryLoadingWrapper>
  );
};

export default Profile;
